import { render, staticRenderFns } from "./IssueForm.vue?vue&type=template&id=4f933580&scoped=true&"
import script from "./IssueForm.vue?vue&type=script&lang=ts&"
export * from "./IssueForm.vue?vue&type=script&lang=ts&"
import style0 from "./IssueForm.vue?vue&type=style&index=0&id=4f933580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f933580",
  null
  
)

export default component.exports